export const ProfileInitialValues = {
  npis: [],
  email:null,
  plans: [],
  firstName: '',
  lastName: '',
}